module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTNI"
  }, [_vm._v("To the bikers on the ferry between Harwich and Esbjerg for all the ideas, and my agent, Laura Bradford for knowing I was a biker chick at heart. And to my fabulous editor Monique Patterson for polishing my manuscript and making it shine, and her assistant Alexandra Sehulster for her patience with my questions about turtle soup. To Jill, Donna, and Bev for their sharp eyes and helpful insights. And always to my family, for their patience, understanding, and ability to act out even the most complicated fight scenes.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b285ee4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0